<template>
  <div class="transfer_items">
    <div class="vx-card vx-row mt-3 py-10">
      <!-- delete product button -->
      <vs-button
        v-if="$parent.totalPackages.length > 1"
        class="delete_package ml-auto cursor-pointer mr-4"
        type="filled"
        color="danger"
        icon-pack="feather"
        icon="icon-trash-2"
        @click="$emit('delete_package')"
      />

      <div class="vx-col w-full">
        <div class="vx-row">
          <!-- category  -->
          <div class="vx-col w-full md:w-1/2 lg:w-1/4 mb-2">
            <label for="">Category <span class="text-danger">*</span></label>
            <select-2
              autocomplete
              class="w-full"
              :value.sync="products.categoryId"
              @input="(item) => (products.categoryId = item && item.value)"
              name="Category"
              placeholder="Select Category"
              v-validate="'required'"
              :options="productCategories"
            />
            <span class="text-danger text-sm" v-show="errors.has('Category')">{{ errors.first('Category') }}</span>
          </div>

          <!-- Batch Number -->
          <div class="vx-col w-full md:w-1/2 lg:w-1/4 mb-2">
            <label for="">Batch Number <span v-if="!isAncillaryAndOthers" class="text-danger">*</span></label>
            <vs-input
              icon="icon icon-list"
              :disabled="[categories.ANCILLARY, categories.OTHER].includes(products.categoryId)"
              icon-pack="feather"
              class="w-full"
              v-validate="{ required: !isAncillaryAndOthers }"
              v-model="products.batch"
              name="Batch Number"
            />
            <span class="text-danger text-sm" v-show="errors.has('Batch Number')">{{ errors.first('Batch Number') }}</span>
          </div>

          <!-- Product Name-->
          <div class="vx-col w-full md:w-1/2 lg:w-1/4 mb-2">
            <label for="">Product Name <span class="text-danger">*</span></label>
            <vs-input icon="icon icon-list" icon-pack="feather" class="w-full" name="Product Name" v-model="products.product_name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Product Name')">{{ errors.first('Product Name') }}</span>
          </div>

          <!--Sales Price -->
          <div class="vx-col w-full md:w-1/2 lg:w-1/4 mb-2 flex items-center">
            <div class="w-full">
              <label for="">Sales Price<span class="text-danger">*</span></label>
              <vs-input type="number" icon="icon icon-list" icon-pack="feather" class="w-full" name="Sales Price" v-model="products.sales_price" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('Sales Price')">{{ errors.first('Sales Price') }}</span>
            </div>
            <div class="mt-auto ml-2">
              <vx-tooltip class="flex-none mt-3" text="This is the price you will sell the product per unit.">
                <vs-icon class="p-2 cursor-pointer" color="primary" radius size="medium" type="flat" icon="info" />
              </vx-tooltip>
            </div>
          </div>

          <!-- Serial Number - plant  -->
          <div class="vx-col w-full md:w-1/2 mb-2" v-if="[categories.PLANT, categories.MATURE].includes(products.categoryId)">
            <label for="">Serial Number <span class="text-danger">*</span></label>
            <vs-input icon="icon icon-list" icon-pack="feather" class="w-full" name="Serial Number" v-model="batchPlantsSerialNumber" />
          </div>

          <!-- Weight Type  -->
          <div class="vx-col w-full md:w-1/2 lg:w-1/4 mb-2" v-if="![categories.PLANT, categories.MATURE].includes(products.categoryId)">
            <label for="">Weight Type <span v-if="!isAncillaryAndOthers" class="text-danger">*</span></label>
            <select-2
              autocomplete
              :disabled="[categories.ANCILLARY, categories.OTHER].includes(products.categoryId)"
              :value="products.weight_type"
              @input="(item) => (products.weight_type = item && item.value)"
              name="Weight Type"
              placeholder="Select Weight Type"
              :options="weightTypeOptions"
              v-validate="{ required: !isAncillaryAndOthers }"
            />
            <span class="text-danger text-sm" v-show="errors.has('Weight Type')">{{ errors.first('Weight Type') }}</span>
          </div>

          <!-- Weight Per Package  -->
          <div class="vx-col w-full md:w-1/2 lg:w-1/4 mb-2" v-if="![categories.PLANT, categories.MATURE].includes(products.categoryId)">
            <label for="">Weight Per Package <span v-if="!isAncillaryAndOthers" class="text-danger">*</span></label>
            <vs-input
              icon="icon icon-list"
              :disabled="[categories.ANCILLARY, categories.OTHER].includes(products.categoryId)"
              type="number"
              v-model="products.weight_per_package"
              icon-pack="feather"
              class="w-full"
              name="Weight Per Package"
              v-validate="{ required: !isAncillaryAndOthers }"
            />
            <span class="text-danger text-sm" v-show="errors.has('Weight Per Package')">{{ errors.first('Weight Per Package') }}</span>
          </div>

          <!-- Quantity -->
          <div class="vx-col w-full md:w-1/2 lg:w-1/4 mb-2">
            <label for="">Quantity <span v-if="!isQuantityRequired" class="text-danger">*</span></label>
            <vs-input
              icon="icon icon-list"
              :disabled="[categories.FLOWER, categories.SHAKE].includes(products.categoryId)"
              type="number"
              v-model="products.quantity"
              @change="handlePlantSerialNumber"
              icon-pack="feather"
              class="w-full"
              name="Quantity"
              v-validate="{ required: !isQuantityRequired }"
            />
            <span class="text-danger text-sm" v-show="errors.has('Quantity')">{{ errors.first('Quantity') }}</span>
          </div>

          <!-- Purchase Price -->
          <div class="vx-col w-full md:w-1/2 lg:w-1/4 mb-2 flex items-center">
            <div class="w-full">
              <label for="">Purchase Price </label>
              <vs-input icon="icon icon-list" type="number" v-model="products.purchase_price" icon-pack="feather" class="w-full" name="Purchase Price" />
            </div>
            <div class="mt-auto ml-2">
              <vx-tooltip class="flex-none mt-3" text="This is the price you paid for the product per unit.">
                <vs-icon class="p-2 cursor-pointer" color="primary" radius size="medium" type="flat" icon="info" />
              </vx-tooltip>
            </div>
          </div>

          <!-- THC -->
          <div class="vx-col w-full md:w-1/2 lg:w-1/4 mb-2" v-if="isExpends">
            <vs-input type="number" step="0.01" v-model="products.thc" icon="icon icon-list" icon-pack="feather" class="w-full" label="THC %" name="THC" />
            <span class="text-danger text-sm" v-show="errors.has('THC')">{{ errors.first('THC') }}</span>
          </div>

          <!-- CBD -->
          <div class="vx-col w-full md:w-1/2 lg:w-1/4 mb-2" v-if="isExpends">
            <vs-input type="number" step="0.01" v-model="products.cbd" icon="icon icon-list" icon-pack="feather" class="w-full" label="CBD %" name="cbd" />
            <span class="text-danger text-sm" v-show="errors.has('cbd')">{{ errors.first('cbd') }}</span>
          </div>

          <!-- terpenoid potency -->
          <div class="vx-col w-full md:w-1/2 lg:w-1/4 mb-2" v-if="isExpends">
            <vs-input type="number" step="0.01" v-model="products.terpenoid_potency" icon="icon icon-list" icon-pack="feather" class="w-full" label="Terpenoid Potency (%)" name="Terpenoid Potency" />
            <span class="text-danger text-sm" v-show="errors.has('Terpenoid Potency')">{{ errors.first('Terpenoid Potency') }}</span>
          </div>

          <!-- plant stage Dropdown -->
          <div class="vx-col w-full md:w-1/2 lg:w-1/4 mb-2 plant-stage-spacing" v-if="isExpends">
            <label>Plant Stage </label>
            <select-2
              autocomplete
              :disabled="![categories.PLANT, categories.MATURE].includes(products.categoryId)"
              class="w-full"
              :value="products.plant_stage"
              @input="
                (item) => {
                  products.plant_stage = item && item.value
                }
              "
              name="Plant Stage"
              placeholder="Select Plant Stage"
              :options="plantStages"
            />
            <span class="text-danger text-sm" v-show="errors.has('Plant Stage')">{{ errors.first('Plant Stage') }}</span>
          </div>

          <!-- Tiered Pricing Group -->
          <div class="vx-col w-full md:w-1/2 lg:w-1/4 mb-2" v-if="isExpends">
            <label for="">Tiered Pricing Group</label>
            <select-2
              autocomplete
              class="w-full"
              :value.sync="products.tieredPricingGroupId"
              @input="(item) => (products.tieredPricingGroupId = item && item.value)"
              name="Tiered Pricing Group"
              placeholder="Select Tiered Pricing Group"
              :options="tieredPricingOptions"
            />
          </div>
        </div>

        <div class="vx-col w-full flex items-center mt-5">
          <vs-button class="mx-auto rounded-full" icon-pack="feather" :icon="!isExpends ? 'icon-plus' : 'icon-minus'" @click="isExpends = !isExpends" type="relief" />
          <div class="total_const">
            <div class="mt-auto ml-2"></div>
            <p class="font-bold text-base" color="danger" icon-pack="feather" icon="icon-trash-2">Total</p>
            <p class="text-3xl font-black">${{ transferDollars }}</p>
          </div>
        </div>
      </div>

      <div class="vx-row mt-5 justify-end">
        <div class="vx-col flex">
          <div
            class="edit_package cursor-pointer font-black underline"
            v-if="$parent.tranStatus === transferStatus.Approved"
            @click="$router.push({ name: 'product-edit', params: { id: products.productId } })"
          >
            Edit Item Details
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { transferStatus } from '@/utils/enums'
import { weightTypes } from '@/utils/weightType'
import { mapState } from 'vuex'

export default {
  name: 'TransferItems',

  components: {
    Select2
  },

  props: {
    itemOptions: Array,
    products: Object,
    productCategories: Array
  },

  data() {
    return {
      transferStatus,
      tieredPricingOptions: [],
      tieredPricingGroupId: null,
      isExpends: false,
      nowTime: Date.now(),
      currIndex: 0,
      weightTypeOptions: weightTypes,
      plantStages: [
        { value: 'seedling', label: 'Seedling' },
        { value: 'pre_veg', label: 'Pre-Veg' },
        { value: 'veg', label: 'Veg' },
        { value: 'flower', label: 'Flower' },
        { value: 'mother', label: 'Mother' }
      ]
    }
  },

  mounted() {
    // remove unit weight type
    this.weightTypeOptions = weightTypes.reduce((acc, item) => {
      if (item.value !== 'unit') {
        acc.push(item)
      }

      return acc
    }, [])

    // get tiered pricing
    this.getTieredPricingOptions()
  },

  computed: {
    ...mapState('product', ['categories']),

    batchPlantsSerialNumber: {
      get() {
        return this.products.batchPlantIds.length ? this.products.batchPlantIds.map((x) => x.serialNumber).join(', ') : null
      },

      set(val) {
        if (val) {
          const tempSerials = val.split(', ')
          this.products.batchPlantIds = tempSerials.reduce((acc, item) => {
            acc.push({
              plantId: null,
              serialNumber: item
            })

            return acc
          }, [])

          if (this.products.batchPlantIds.length !== this.products.quantity) {
            this.products.quantity = this.products.batchPlantIds.length
          }
        } else {
          this.products.batchPlantIds = []
        }
      }
    },

    validateForm() {
      return !this.errors.any()
    },

    isQuantityRequired() {
      return [this.categories.FLOWER, this.categories.SHAKE, this.categories.WASTE, this.categories.WHOLEWETPLANT].includes(this.products.categoryId)
    },

    isAncillaryAndOthers() {
      return this.products.categoryId === this.categories.ANCILLARY || this.products.categoryId === this.categories.OTHER
    },

    // calculate total transfer dollar
    transferDollars() {
      return (
        Number(this.products.purchase_price) *
          Number(this.products.categoryId === this.categories.FLOWER || this.products.categoryId === this.categories.SHAKE ? this.products.weight_per_package : this.products.quantity) || 0
      )
    }
  },

  methods: {
    categoryChange() {
      this.products.quantity = 0
      this.batchPlantsSerialNumber = null
      this.products.plant_stage = null
    },

    handlePlantSerialNumber() {
      if (![this.categories.MATURE, this.categories.PLANT].includes(this.products.categoryId)) {
        return false
      }

      const serialNumberLen = this.batchPlantsSerialNumber ? this.batchPlantsSerialNumber.split(', ').length : 0
      if (serialNumberLen < this.products.quantity) {
        const newSerialNumbers = new Array(Number(this.products.quantity) - serialNumberLen)
          .fill(null)
          .reduce((acc, item) => {
            acc.push(`SN${this.nowTime}_${this.currIndex}`)
            this.currIndex++
            return acc
          }, [])
          .join(', ')

        if (this.batchPlantsSerialNumber) {
          this.batchPlantsSerialNumber += serialNumberLen ? `, ${newSerialNumbers}` : `${newSerialNumbers}`
        } else {
          this.batchPlantsSerialNumber = serialNumberLen ? `, ${newSerialNumbers}` : `${newSerialNumbers}`
        }
      } else {
        this.batchPlantsSerialNumber = this.batchPlantsSerialNumber.split(', ').splice(0, this.products.quantity).join(', ')
      }
    },

    // get tiered pricing options
    async getTieredPricingOptions() {
      this.$store
        .dispatch('setting/getTieredPricingList', { page: 1, limit: 0 })
        .then((res) => {
          this.tieredPricingOptions = res.data.reduce((acc, item) => {
            const tempObj = {}
            tempObj.label = item.pricing_group_name
            tempObj.value = item.id

            acc.push(tempObj)

            return acc
          }, [])
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  },

  watch: {
    'products.categoryId': {
      immediate: true,
      handler() {
        this.categoryChange()
      }
    }
  }
}
</script>

<style >
.plant-stage-spacing .input-select-con {
  margin-right: 40px !important;
}
</style>
